import { render, staticRenderFns } from "./OtpModal.vue?vue&type=template&id=3ddd5c04&scoped=true"
import script from "./OtpModal.vue?vue&type=script&lang=js"
export * from "./OtpModal.vue?vue&type=script&lang=js"
import style0 from "./OtpModal.vue?vue&type=style&index=0&id=3ddd5c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddd5c04",
  null
  
)

export default component.exports